import { FuseNavigation } from "@fuse/types";
import { Menus } from "../shared/constants/menu.constant";

export const navigation: FuseNavigation[] = [
    {
        id: Menus.DASHBOARD,
        title: "Dashboard",
        type: "item",
        url: "/dashboard",
        icon: "dashboard",
    },
    {
        id: Menus.ATTENDANCE,
        title: "Attendance",
        type: "item",
        url: "/attendance",
        icon: "description",
    },
    {
        id: Menus.DOCUMENT_VAULT,
        title: "Document Vault Master",
        type: "item",
        url: "/documentVault",
        icon: "description",
    },
    {
        id: "Master",
        title: "Master",
        type: "collapsable",
        icon: "list",
        children: [
            {
                id: Menus.BRANCH,
                title: "Branch Master",
                type: "item",
                url: "/master/branch",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.EDUCATION,
                title: "Education Master",
                type: "item",
                url: "/master/education",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.Location,
                title: "Location Master",
                type: "item",
                url: "/master/location",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.DEPARTMENT,
                title: "Department Master",
                type: "item",
                url: "/master/department",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.DESIGNATION,
                title: "Designation Master",
                type: "item",
                url: "/master/designation",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.SHIFT,
                title: "Shift Master",
                type: "item",
                url: "/master/shift",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.SHIFT_GROUP,
                title: "Shift Group Master",
                type: "item",
                url: "/master/shift-group",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.EMPLOYEE,
                title: "Employee Master",
                type: "item",
                url: "/master/employee",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.PERMANENT_EMPLOYEE,
                title: "Permanent Employee",
                type: "item",
                url: "/master/permanent-employee",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.EMPLOYEE_SHIFT_ASSIGN,
                title: "Employee Shift Assign",
                type: "item",
                url: "/master/employee-shift-assign",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.EMPLOYEE_INCREMENT,
                title: "Employee Increment",
                type: "item",
                url: "/master/employee-increment",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.EMPLOYEE_CHECKLIST,
                title: "Employee Checklist",
                type: "item",
                url: "/master/employee-checklist",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.ORGANIZATION_CHART,
                title: "ORG Chart",
                type: "item",
                url: "/master/organization-chart",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.PROJECT_MASTER,
                title: "Project Master",
                type: "item",
                url: "/master/project-master",
                icon: "panorama_fish_eye",
            },
        ],
    },
    {
        id: "Transaction",
        title: "Transaction",
        type: "collapsable",
        icon: "history",
        children: [
            {
                id: Menus.THUMB_APPLICATION,
                title: "Thumb Application",
                type: "item",
                url: "/transaction/thumb-application",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.EMPLOYEE_TRAINING_APPLICATION,
                title: "Employee Training",
                type: "item",
                url: "/transaction/employee-training-application",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.HOLIDAY_APPLICATION,
                title: "Holiday Application",
                type: "item",
                url: "/transaction/holiday-application",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.LEAVE_APPLICATION,
                title: "Leave Application",
                type: "item",
                url: "/transaction/leave-application",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.WORK_FROM_HOME,
                title: "Work From Home",
                type: "item",
                url: "/transaction/work-from-home",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.CLARIFICATION_APPLICATION,
                title: "Clarification Application",
                type: "item",
                url: "/transaction/clarification-application",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.OVERTIME_APPLICATION,
                title: "Overtime Application",
                type: "item",
                url: "/transaction/over-time-application",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.COMPENSATION_APPLICATION,
                title: "Compensation Application",
                type: "item",
                url: "/transaction/compensation-application",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.FUEL_ALW_APPLICATION,
                title: "Fuel Alw Application",
                type: "item",
                url: "/transaction/fuel-allowance-application",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.RESIGN_APPLICATION,
                title: "Resign Application",
                type: "item",
                url: "/transaction/resign-application",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.EXTRAPAY_APPLICATION,
                title: "Extrapay Application",
                type: "item",
                url: "/transaction/extra-pay-application",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.REQUEST_MODULE,
                title: "Request Application",
                type: "item",
                url: "/transaction/request-module",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.CALCULATE_MONTH_SALARY,
                title: "Calculate Month Salary",
                type: "item",
                url: "/transaction/calculate-month-salary",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.CALCULATE_FINAL_ATTENDACE,
                title: "Calculate Final Attendance",
                type: "item",
                url: "/transaction/calculate-final-attendace",
                icon: "panorama_fish_eye",
            },
        ],
    },
    {
        id: "Report",
        title: "Report",
        type: "collapsable",
        icon: "description",
        children: [
            {
                id: Menus.ATTENDANCE_REPORT,
                title: "Attendance Report",
                type: "item",
                url: "/report/attendance-report",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.MONTHLY_SUMMARY_REPORT,
                title: "Monthly Summary Report",
                type: "item",
                url: "/report/attendance-monthly-summary-report",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.DAILY_DETAIL_REPORT,
                title: "Daily Detail Report",
                type: "item",
                url: "/report/daily-detail-report",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.INOUT_REPORT,
                title: "InOut  Report",
                type: "item",
                url: "/report/inout-report",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.LATE_EARLY_REPORT,
                title: "Late/Early Report",
                type: "item",
                url: "/report/late-early-report",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.SHORT_HOUR_REPORT,
                title: "Short Hour Report",
                type: "item",
                url: "/report/short-hour-report",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.MISSING_THUMB_REPORT,
                title: "Missing Thumb Report",
                type: "item",
                url: "/report/missing-thumb-report",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.CLARIFICATION_REPORT,
                title: "Clarification Report",
                type: "item",
                url: "/report/clarification-report",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.LEAVE_BALANCE,
                title: "Leave Balance Report",
                type: "item",
                url: "/report/leave-balance",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.FUEL_ALW_REPORT,
                title: "Fuel Alw Report",
                type: "item",
                url: "/report/fuel-alw-report",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.DTA_REPORT,
                title: "DTA Report",
                type: "item",
                url: "/report/dta-report",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.SALARY_REPORT,
                title: "Salary Report",
                type: "item",
                url: "/report/salary-report",
                icon: "panorama_fish_eye",
            },
            // {
            //     id: Menus.TDS_REPORT,
            //     title: "TDS Report",
            //     type: "item",
            //     url: "/report/tds-report",
            //     icon: "panorama_fish_eye",
            // },
            {
                id: Menus.SALARY_SUMMARY_REPORT,
                title: "Salary Summary Report",
                type: "item",
                url: "/report/salary-summary-report",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.INCREMENT_REPORT,
                title: "Increment Detail Report",
                type: "item",
                url: "/report/increment-report",
                icon: "panorama_fish_eye",
            },

        ],
    },
    {
        id: 'Payroll Pages',
        title: 'Payroll',
        type: 'collapsable',
        icon: 'attach_money',
        children: [

            {
                id: Menus.PF_MASTER,
                title: 'PF Master',
                type: 'item',
                url: '/payroll-master/pf-master',
                icon: 'panorama_fish_eye'
            },
            {
                id: Menus.ESIC_MASTER,
                title: 'ESIC Master',
                type: 'item',
                url: '/payroll-master/esic-master',
                icon: 'panorama_fish_eye'
            },
            {
                id: Menus.LWF_MASTER,
                title: 'LWF Master',
                type: 'item',
                url: '/payroll-master/lwf-master',
                icon: 'panorama_fish_eye'
            },
            {
                id: Menus.ALLOWANCE_MASTER,
                title: 'Allownce Master',
                type: 'item',
                url: '/payroll-master/allownce-master',
                icon: 'panorama_fish_eye'
            },
            {
                id: Menus.SALARY_STRUCTURE_MASTER,
                title: ' Salary Structure Master',
                type: 'item',
                url: '/payroll-master/salary-structure-master',
                icon: 'panorama_fish_eye'
            },
            {
                id: Menus.SALARY_STRUCTURE_DETAIL,
                title: ' Salary Structure Detail',
                type: 'item',
                url: '/payroll-master/salary-structure-detail',
                icon: 'panorama_fish_eye'
            },
            {
                id: Menus.FUEL_ALW_MASTER,
                title: "Fuel Alw Master",
                type: "item",
                url: "/payroll-master/fuel-allowance-master",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.DTA_MASTER,
                title: 'DTA Master',
                type: 'item',
                url: '/payroll-master/dta-master',
                icon: 'panorama_fish_eye'
            },
            {
                id: Menus.ADVANCE_PAID,
                title: 'Advance Paid',
                type: 'item',
                url: '/payroll-master/advance-paid',
                icon: 'panorama_fish_eye'
            },
            {
                id: Menus.BONUS_DETAILS,
                title: 'Bonus Details',
                type: 'item',
                url: '/payroll-master/bonus-details',
                icon: 'panorama_fish_eye'
            },
            {
                id: Menus.LEAVE_ENCASHMENT,
                title: 'Leave Encashment',
                type: 'item',
                url: '/payroll-master/leave-encashment',
                icon: 'panorama_fish_eye'
            },
            {
                id: Menus.INCOME_TAX_SLAB,
                title: 'Income Tax Slab',
                type: 'item',
                url: '/payroll-master/income-tax-slab',
                icon: 'panorama_fish_eye'
            },
            {
                id: Menus.INVESTMENT_SCHEMA_MASTER,
                title: 'Investment Schema',
                type: 'item',
                url: '/payroll-master/investment-schema',
                icon: 'panorama_fish_eye'
            },
            {
                id: Menus.INVESTMENT_DETAIL,
                title: 'Investment Detail',
                type: 'item',
                url: '/payroll-master/investment-detail',
                icon: 'panorama_fish_eye'
            },
            {
                id: Menus.EMPLOYEE_ITMETHOD,
                title: 'Employee IT Method',
                type: 'item',
                url: '/payroll-master/employee-itmethod',
                icon: 'panorama_fish_eye'
            },
            {
                id: Menus.FORM_16_REPORT,
                title: 'Form 16 Report',
                type: 'item',
                url: '/payroll-master/form-report',
                icon: 'panorama_fish_eye'
            },
            {
                id: Menus.YEARLY_TRANSFER,
                title: 'Yearly Transfer',
                type: 'item',
                url: '/payroll-master/yearly-transfer',
                icon: 'panorama_fish_eye'
            },
        ]
    },
    {
        id: 'Utility Pages',
        title: 'Utility',
        type: 'collapsable',
        icon: 'build',
        children: [
            {
                id: Menus.COMPANY_MASTER,
                title: "Company Master",
                type: "item",
                url: "/utility/company",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.ROLE_MASTER,
                title: "Role Master",
                type: "item",
                url: "/utility/role",
                icon: "panorama_fish_eye",
            },

            {
                id: Menus.USER_MASTER,
                title: "User Master",
                type: "item",
                url: "/utility/user",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.BANK_MASTER,
                title: "Bank Master",
                type: "item",
                url: "/utility/bank",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.HOLIDAY_MASTER,
                title: "Holiday Master",
                type: "item",
                url: "/utility/holiday",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.LEAVE_MASTER,
                title: "Leave Master",
                type: "item",
                url: "/utility/leave",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.COMPENSATION_MASTER,
                title: "Compensation Master",
                type: "item",
                url: "/utility/compensation-master",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.PROFESSIONAL_TAX_MASTER,
                title: "Professional Tax Master",
                type: "item",
                url: "/utility/professtional-tax",
                icon: "panorama_fish_eye",
            },

            {
                id: Menus.DOCUMENT_TYPE_MASTER,
                title: "Document Type Master",
                type: "item",
                url: "/utility/document-type",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.PAYMENT_TYPE_MASTER,
                title: "Payment Type Master",
                type: "item",
                url: "/utility/payment-type",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.CHECK_LIST_MASTER,
                title: "Check List Master",
                type: "item",
                url: "/utility/check-list",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.ASSET_MASTER,
                title: "Asset Master",
                type: "item",
                url: "/utility/asset-master",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.ASSET_MANAGEMENT,
                title: "Asset Management",
                type: "item",
                url: "/utility/asset-management",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.MENU_ACCESS_UTILITY,
                title: "Menu Access Utility",
                type: "item",
                url: "/utility/menu-access",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.INSTRUCTION_MASTER,
                title: "Instruction Master",
                type: "item",
                url: "/utility/instruction-master",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.GENERATE_LETTER,
                title: "Generate Letter",
                type: "item",
                url: "/utility/generate-letter",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.DEVICE_SETTING,
                title: "Device Setting",
                type: "item",
                url: "/utility/device-setting",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.EMAIL_TEMPLATE,
                title: "Email Template",
                type: "item",
                url: "/utility/email-template",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.EMAIl_SETTING,
                title: "Email Setting",
                type: "item",
                url: "/utility/email-setting",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.CUSTOM_EMAIL,
                title: "Custom Email",
                type: "item",
                url: "/utility/custom-email",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.RULE_MASTER,
                title: "Rule Master",
                type: "item",
                url: "/utility/rule",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.WEEKEND_SETTING,
                title: "Weekend Setting",
                type: "item",
                url: "/utility/weekend-setting",
                icon: "panorama_fish_eye",
            },
            {
                id: Menus.GENERAL_SETTING,
                title: "General Setting",
                type: "item",
                url: "/utility/general-setting",
                icon: "panorama_fish_eye",
            },

        ],
    },
];
